import { useState, useRef, useEffect } from "react";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import classes from "./BankBankRecon.module.css";
import { Calendar } from "lucide-react";
import printer from "../../Assets/Printer.png";
import tick from "../../Assets/check.png";
import refresh from "../../Assets/ArrowsClockwise.png";
import save from "../../Assets/FloppyDisk.png";
import cancel from "../../Assets/X.png";
import uploadbtn from "../../Assets/UploadSimple.png";
import filenotify from "../../Assets/fileicon.png";
import fileinfo from "../../Assets/Info.png";
import downloadbtn from "../../Assets/DownloadSimple.png";
import chat from "../../Assets/ChatCircle.png";
import Footer from "../../Components/Footer/Footer";
import { Link, useLocation, useNavigate } from "react-router";
import * as XLSX from 'xlsx';

const BankStatementPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const uploadedFiles = location.state?.files || [];
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [excelData, setExcelData] = useState(null);

  // Parse Excel file using the xlsx library
  useEffect(() => {
    if (uploadedFiles.length > 0 && (uploadedFiles[currentFileIndex]?.name.endsWith('.xlsx') || uploadedFiles[currentFileIndex]?.name.endsWith('.xls'))) {
      parseExcelFile(uploadedFiles[currentFileIndex]);
    }
  }, [currentFileIndex, uploadedFiles]);

  const parseExcelFile = async (fileData) => {
    try {
      // Convert base64 to binary string
      const bstr = atob(fileData.data.split(',')[1]);
      const ab = new ArrayBuffer(bstr.length);
      const view = new Uint8Array(ab);
      for (let i = 0; i < bstr.length; i++) {
        view[i] = bstr.charCodeAt(i) & 0xFF;
      }
      
      // Parse workbook
      const workbook = XLSX.read(ab, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      
      // Convert to JSON
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(data);
    } catch (error) {
      console.error('Error parsing Excel file:', error);
      setExcelData(null);
    }
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Current Month");
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarClick = (e) => {
    e.stopPropagation();
    inputRef.current.showPicker(); // shows native picker in modern browsers
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    const monthName = new Date(e.target.value).toLocaleString("default", {
      month: "long",
    });
    setSelectedMonth(`${monthName} ${year}`);
  };

  const handleUploadDifferentFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e) => {
    if (e.target.files) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = (files) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      const fileData = [];
      let filesRead = 0;

      fileArray.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          fileData.push({
            name: file.name,
            type: file.type,
            size: file.size,
            data: reader.result,
          });
          filesRead++;

          if (filesRead === fileArray.length) {
            console.log("Files selected:", fileData);
            navigate("/accounting/bankstatement-preview", { state: { files: fileData } });
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };
  return (
    <div className={classes.bodyxyz}>
      <HeaderNav />
      <section className={classes.bankbody}>
        {/* <div className={classes.actions}>
          <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
          <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
          <button className={classes.btnst}>Reconcilation</button>
          <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
        </div> */}

        <header className={classes.header}>
          <div className={classes.header1}>
            <h2 className={classes.Title}>Review Bank Statement</h2>
            <h1 className={classes.Titles}>
              Check that this is the correct file before submitting for reconciliation
            </h1>
          </div>
          <div className={classes.header2}>
            <div className={classes.wrapper} ref={wrapperRef}>
              <div
                className={classes.combobox}
                onClick={handleUploadDifferentFile}
              > <span className={classes.comboboxText}>Upload different file </span>

                <input
                  ref={fileInputRef}
                  type="file"
                  className={classes.hiddenInput}
                  onChange={handleFileInputChange}
                  accept=".pdf,.csv,.xlsx,.xls"
                  style={{ display: 'none' }}
                />
              </div>
            </div>
          </div>
        </header>

        {uploadedFiles.length > 0 && (
          <div className={classes.filePreviewdtls}>
            <img src={filenotify} alt="File" className={classes.filenotify} />
            <div>
              <p className={classes.filenamestle}>{uploadedFiles[currentFileIndex]?.name}</p>
              <div className={classes.filetypesdtls}>
                <p style={{ marginBottom: '0px'}}>{uploadedFiles[currentFileIndex]?.type.split('/')[1].toUpperCase() || 'FILE'}</p>
                <p style={{ marginBottom: '0px'}}>•</p>
                <p style={{ marginBottom: '0px'}}>{(uploadedFiles[currentFileIndex]?.size / 1024).toFixed(2)} KB</p>
                <p style={{ marginBottom: '0px'}}>•</p>
                <p style={{ marginBottom: '0px'}}>Uploaded just now</p>
              </div>
            </div>
          </div>
        )}
        <div className={classes.filePreviewdtlsii}> 
          <img src={fileinfo} alt="Download" className={classes.fileinfo} />
          <p className={classes.reviewtxt}>Review carefully. Make sure the dates, amounts, and account match what you expect before submitting. You can upload a different file if something looks wrong.</p>
        </div>
      </section>
      <section className={classes.cardsect}>
        <div className={classes.reconciliationContainer}>
          {uploadedFiles.length > 0 ? (
            <div className={classes.filePreviewSection}>
              {uploadedFiles[currentFileIndex]?.type.includes('pdf') ? (
                <iframe
                  src={uploadedFiles[currentFileIndex]?.data}
                  className={classes.pdfPreview}
                  title="PDF Preview"
                />
              ) : uploadedFiles[currentFileIndex]?.name.endsWith('.xlsx') || uploadedFiles[currentFileIndex]?.name.endsWith('.xls') ? (
                <div className={classes.spreadsheetPreview}>
                  {excelData && excelData.length > 0 ? (
                    <table className={classes.excelTable}>
                      <tbody>
                        {excelData.slice(0, 100).map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                              <td key={cellIndex}>{cell || ''}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className={classes.excelLoadingContainer}>
                      <p className={classes.previewPlaceholder}>Loading Excel file...</p>
                      <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                    </div>
                  )}
                </div>
              ) : uploadedFiles[currentFileIndex]?.type.includes('spreadsheet') || uploadedFiles[currentFileIndex]?.name.endsWith('.csv') ? (
                <div className={classes.spreadsheetPreview}>
                  <p className={classes.previewPlaceholder}>Spreadsheet file preview</p>
                  <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                </div>
              ) : (
                <div className={classes.filePreviewPlaceholder}>
                  <p className={classes.previewPlaceholder}>File Preview</p>
                  <p className={classes.previewSubtext}>{uploadedFiles[currentFileIndex]?.name}</p>
                </div>
              )}
              {uploadedFiles.length > 1 && (
                <div className={classes.fileNavigationButtons}>
                  <button
                    onClick={() => setCurrentFileIndex((prev) => (prev > 0 ? prev - 1 : uploadedFiles.length - 1))}
                    className={classes.navButton}
                  >
                    Previous
                  </button>
                  <span>{currentFileIndex + 1} of {uploadedFiles.length}</span>
                  <button
                    onClick={() => setCurrentFileIndex((prev) => (prev < uploadedFiles.length - 1 ? prev + 1 : 0))}
                    className={classes.navButton}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className={classes.noFilesPlaceholder}>
              <p>No file uploaded. Please upload a bank statement to preview.</p>
            </div>
          )}
        </div>
      </section>
<div className={classes.btnsubmit}>
  <button className={classes.cnclbtn}>Cancel </button>
  <button className={classes.submitbtn}>Submit Statement </button>
</div>

      <Footer />
    </div>
  );
};

export default BankStatementPreview;
